import * as React from 'react';

import classnames from '../utils/classnames.tsx';
import { IDLE, Pose } from './worki/Pose.tsx';
import Worki from './worki/Worki.tsx';

export interface EmptyStageProps extends Omit<React.ComponentPropsWithRef<'div'>, 'title'> {
    title: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
    pose?: Pose;
    size?: number;
}

const EmptyStage = ({ title, description, action, pose = IDLE, size = 110, className, ...props }: EmptyStageProps) => (
    <div {...props} className={classnames('flex flex-1 flex-col items-center justify-center px-6 py-8', className)}>
        <div className="mb-6">
            <Worki pose={pose} size={size} trackMouse="page" />
        </div>
        <span className="m-0 mb-1.5 text-sm font-semibold text-content-strong">{title}</span>
        {description && <p className="m-0 mb-6 max-w-md text-center text-sm text-content-medium">{description}</p>}
        {action}
    </div>
);

export default EmptyStage;
